import { Progress as ProgressPrimitive } from "@base-ui/react/progress"
import classNames from "classnames"
import React from "react"

import { Color } from "@constants/V2/color"
import { getBackgroundColorClass } from "@utils/V2/color"

type ProgressProps = ProgressPrimitive.Root.Props & {
  indicatorColor?: Color
}

const Progress = ({
  className,
  children,
  value,
  indicatorColor = Color.Blue,
  ...props
}: ProgressProps) => {
  return (
    <ProgressPrimitive.Root
      value={value}
      data-slot="progress"
      className={classNames("flex flex-wrap gap-3", className)}
      {...props}
    >
      {children}
      <ProgressTrack>
        <ProgressIndicator
          className={getBackgroundColorClass(indicatorColor)}
        />
      </ProgressTrack>
    </ProgressPrimitive.Root>
  )
}

const ProgressTrack = ({
  className,
  ...props
}: ProgressPrimitive.Track.Props) => {
  return (
    <ProgressPrimitive.Track
      className={classNames(
        "relative h-[2px] w-full overflow-hidden",
        getBackgroundColorClass(Color.Gray),
        className
      )}
      data-slot="progress-track"
      {...props}
    />
  )
}

const ProgressIndicator = ({
  className,
  ...props
}: ProgressPrimitive.Indicator.Props) => {
  return (
    <ProgressPrimitive.Indicator
      data-slot="progress-indicator"
      className={classNames("bg-primary h-[2px] transition-all", className)}
      {...props}
    />
  )
}

const ProgressLabel = ({
  className,
  ...props
}: ProgressPrimitive.Label.Props) => {
  return (
    <ProgressPrimitive.Label
      className={classNames("text-sm font-medium", className)}
      data-slot="progress-label"
      {...props}
    />
  )
}

const ProgressValue = ({
  className,
  ...props
}: ProgressPrimitive.Value.Props) => {
  return (
    <ProgressPrimitive.Value
      className={classNames(
        "text-sm text-muted-foreground ml-auto tabular-nums",
        className
      )}
      data-slot="progress-value"
      {...props}
    />
  )
}

export {
  Progress,
  ProgressTrack,
  ProgressIndicator,
  ProgressLabel,
  ProgressValue,
}
